import { render, staticRenderFns } from "./PageBatchBuyOrder.vue?vue&type=template&id=45a96f9b&scoped=true"
import script from "./PageBatchBuyOrder.vue?vue&type=script&lang=js"
export * from "./PageBatchBuyOrder.vue?vue&type=script&lang=js"
import style0 from "./PageBatchBuyOrder.vue?vue&type=style&index=0&id=45a96f9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a96f9b",
  null
  
)

export default component.exports